import { gql } from '@apollo/client/core';
import { executeQuery } from '@/components/commons/utils.js';

const EXP_QUERY = gql `
    query alchemistSession($hashKey: String, $identityId: String, $deviceId: String, $isMobile: Boolean) {
      getAlchemistSession(hashKey: $hashKey, identityId: $identityId, deviceId: $deviceId, isMobile: $isMobile){
            message
            success

            session {
                hashKey
                features
            }
        }
    }
`

export async function startSession(hashKey, identityId, deviceId, isMobile) {
    try {
        const result = await executeQuery(EXP_QUERY, {
            hashKey, identityId, deviceId, isMobile
        },  { fetchPolicy: 'network-only' } );

        return result
    } catch (error) {
        console.log(error)
    }
}

